import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../../types";
import { Note } from "./types";
import { transformMetadata, processTimestampFields } from "../../../utils";

export type NoteOnSnapshotCollectionService<T> = (
  agentId: string,
  workplaceId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: NoteOnSnapshotCollectionService<EntityGet<Note>> = (
  agentId,
  workplaceId,
  opts: ListServiceOpts,
  callback,
  onError = () => {}
) => {
  const collectionRef = collection(
    db,
    `/agent/${agentId}/workplace/${workplaceId}/note`
  );
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Note>,
                doc.metadata
              )
            ) as EntityGet<Note>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
